import script from "./Welcome20710.vue?vue&type=script&setup=true&lang=ts"
export * from "./Welcome20710.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__